import i18next from "i18next";
import { useNavigate } from "react-router";
import Button from "../components/Button";
import Label from "../components/Label";
import SimpleDialog from "../components/SimpleDialog";
import { routes, utils } from "../utils";
import { useEffect } from "react";

const i18Listkey = "entity-list2";
// const i18Listkey = "samples-list";
const i18Createkey = "entity-create2";
// const i18Createkey = i18Createkey;

export default function Dashboard() {
	const navigate = useNavigate();

	const goBack = () => navigate("/", { replace: true });

	const isAdmin = utils.isAdmin();
	const isCollaboratorOrAdmin = utils.isAdminOrCollaborator();

	useEffect(() => {
		if (!utils.isAdminOrCollaborator()) {
			navigate(routes.HOME);
		}
	}, []);

	return (
		<SimpleDialog open={true} onClose={goBack} style={{ minWidth: 200, maxWidth: 430 }}>
			<Label text={i18next.t("menu")} isTitle />
			<div className="mt-3">
				<Label className="mb-1" text={i18next.t("extractions")} />
				<div className="grid-container">
					<Button
						buttonClass="w-100"
						label={i18next.t(i18Createkey, { entity: i18next.t("Extraction") })}
						onClick={() => navigate("." + routes.CREATE_EXTRACTION)}
						visible={isCollaboratorOrAdmin}
					/>
					<Button
						buttonClass="w-100"
						label={i18next.t(i18Listkey, { entity: i18next.t("Extractions") })}
						onClick={() => navigate(routes.EXTRACTION_LIST)}
					/>
				</div>
			</div>

			<div className="mt-3">
				<Label className="mb-1" text={i18next.t("samples")} />
				<div className="grid-container">
					<Button
						buttonClass="w-100"
						label={i18next.t(i18Createkey, { entity: i18next.t("Sample") })}
						onClick={() => navigate("." + routes.CREATE_SAMPLE)}
						visible={isCollaboratorOrAdmin}
					/>
					<Button
						buttonClass="w-100"
						label={i18next.t(i18Listkey, { entity: i18next.t("Samples") })}
						onClick={() => navigate(routes.SAMPLE_LIST)}
					/>
				</div>
			</div>

			<Label className="mb-1 mt-3" text={i18next.t("basins")} />
			<div className="grid-container">
				<Button
					buttonClass="w-100"
					label={i18next.t(i18Createkey, { entity: i18next.t("Basin") })}
					onClick={() => navigate("." + routes.BASIN_CREATE)}
					visible={isCollaboratorOrAdmin}
				/>
				<Button
					buttonClass="w-100"
					label={i18next.t(i18Listkey, { entity: i18next.t("Basins") })}
					onClick={() => navigate(routes.BASINS_LIST)}
				/>
			</div>

			<Label className="mb-1 mt-3" text={i18next.t("formations")} />
			<div className="grid-container">
				<Button
					buttonClass="w-100"
					label={i18next.t(i18Createkey, { entity: i18next.t("Formation") })}
					onClick={() => navigate("." + routes.FORMATION_CREATE)}
					visible={isCollaboratorOrAdmin}
				/>
				<Button
					buttonClass="w-100"
					label={i18next.t(i18Listkey, { entity: i18next.t("Formations") })}
					onClick={() => navigate(routes.FORMATIONS_LIST)}
				/>
			</div>

			<Label className="mb-1 mt-3" text={i18next.t("locations")} />
			<div className="grid-container">
				<Button
					buttonClass="w-100"
					label={i18next.t(i18Createkey, { entity: i18next.t("Location") })}
					onClick={() => navigate("." + routes.LOCATION_CREATE)}
					visible={isCollaboratorOrAdmin}
				/>
				<Button
					buttonClass="w-100"
					label={i18next.t(i18Listkey, { entity: i18next.t("Locations") })}
					onClick={() => navigate(routes.LOCATIONS_LIST)}
				/>
			</div>

			{isCollaboratorOrAdmin && (
				<div className="mt-3">
					<Label className="mb-1" text={i18next.t("load-data")} />
					<div className="grid-container">
						<Button
							buttonClass="w-100"
							label={i18next.t("upload-file")}
							onClick={() => navigate("." + routes.UPLOAD_FILE)}
							visible={isCollaboratorOrAdmin}
						/>
					</div>
				</div>
			)}

			<div className="mt-3">
				<Label className="mb-1" text={i18next.t("users")} />
				<div className="grid-container">
					{isAdmin && (
						<>
							<Button
								buttonClass="w-100"
								label={i18next.t(i18Createkey, { entity: i18next.t("User") })}
								onClick={() => navigate("." + routes.CREATE_USER)}
							/>
							<Button
								buttonClass="w-100"
								label={i18next.t(i18Listkey, { entity: i18next.t("Users") })}
								onClick={() => navigate(routes.USERS_LIST)}
							/>
						</>
					)}
					<Button
						buttonClass="w-100"
						label={i18next.t("my-user")}
						onClick={() => navigate(routes.USER(utils.getCurrentUser().id))}
					/>
				</div>
			</div>
		</SimpleDialog>
	);
}
